import React, { useState, useEffect, useRef, useCallback } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Button from "../../components/controls/button/Button";
import {
  AddIconSvg,
  ArrowRepeatAllIcon,
  // CalendarIcon,
  // MeatBallsMenuIcon,
  // MeetingsClockIcon,
  RegularArrowDownIcon,
  Cross,
  SearchIcon,
} from "../../modules/default-svg";
import styles from "./MeetingStyles.module.scss";
import Calendar from "../../assets/svg/Calendar.svg";
import Modal from "../../components/controls/modal/Modal";
import Input from "../../components/controls/input/customInput/CustomInput";
// import Toggle from "../../components/controls/toggle/Toggle";
// import DropDown from "../../components/controls/dropdown/DropdownFluent";
import Searchable from "../../components/controls/select/CustomSelect";
// import Repeat from "../../assets/svg/repeat.svg";
import Person from "../../assets/svg/Person.svg";
// import Clock from "../../assets/svg/Clock.svg";
// import ArrowForward from "../../assets/svg/arrow_forward.svg";
import NotesIcon from "../../assets/svg/notes.svg";
import Pencil from "../../assets/svg/pencil.svg";
// import {
//   convertToISOString,
//   parseDateTime,
//   meetingRepeatTypes,
// } from "../../helpers/utils";
import searchService from "../../store/services/search.service";
import CustomPopover from "../../components/popover/Popover";
import IconInput from "../../components/controls/input/iconInput/IconInput";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  AvatarGroup,
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  // PopoverTrigger,
  // Popover,
  // PopoverSurface,
  AvatarGroupItem,
  AvatarGroupPopover,
  partitionAvatarGroupItems,
} from "@fluentui/react-components";

import {
  AddPersonIcon,
  // DeleteIcon,
  // DismissSvg,
} from "../../modules/default-svg";
import NotesItem from "./NotesItem";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { connect } from "react-redux";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import meetingService from "../../store/services/meeting.service";
import { generalActions } from "../../store/actions";
import { debounce, set } from "lodash";
import MeetingDays from "./meetingsDays/MeetingDays";
import "./MeetingStylesOverrides.scss";
import MinimalistToggle from "../../components/controls/toggle/MinimalistToggle";
import EventPopup from "./meetingEventPopup/EventPopup";
import Projects from "../../assets/svg/Projects.svg";
import { utcToLocalTimeString } from "../../utils/systemSettings";
import { Tooltip } from "bootstrap";
import UserSelect from "../../components/userSelect/UserSelect";
import { UserSearchRefType } from "../../helpers/utils";

let tooltipInstance = null;

const Meetings = (props) => {
  const {
    meetings,
    createMeetingRequest,
    updateMeetingRequest,
    // meeting,
    // fetchMeeting,
    getMeetings,
    cancelMeetingRequest,
    deleteMeetingRequest,
    loading,
  } = props;

  const user = JSON.parse(localStorage.getItem("user"));
  const userInfoDto = {
    id: user.id,
    name: user.fullName,
    title: user.title,
    phoneNumber: user.phoneNumber,
    isExternal: user.isExternal,
    isActive: user.isActive,
    email: user.email,
    image: user.profilePictureUrl
  }
  const settings = JSON.parse(localStorage.getItem("settings"));
  const dateFormat = settings?.regionalSettings?.dateFormat;
  const timeFormat = "HH:mm";
  const permissions = localStorage.getItem("permissions");
  const calendarRef = useRef(null);
  const popoverRef = useRef(null);
  const dispatch = useDispatch();
  const [calendarDates, setCalendarDates] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isKeepModalOpen, setIsKeepModalOpen] = useState(false);
  const [isEditingDisabled, setIsEditingDisabled] = useState(false);
  const [eventActionType, setEventActionType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [popoverOpen, setPopoverOpen] = useState(null);
  const [openPopover, setIsOpenPopover] = useState();
  const [showNotes, setShowNotes] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [eventPopupData, setEventPopupData] = useState(null);
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [currentEvents, setCurrentEvents] = useState([]);
  const [eventsList, setEventsList] = useState([]);
  const [todaysEventsList, setTodaysEventsList] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState("");
  const [project, setProject] = useState({ name: "All Projects", id: "all" });
  const [projects, setProjects] = useState([]);
  const [meetingProjects, setMeetingProjects] = useState([]);

  // Meeting State
  const [isOccurrence, setIsOccurrence] = useState(false);
  // const [parentMeetingId, setParentMeetingId] = useState(null);
  const [Name, setName] = useState("");
  const [attendees, setAttendees] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isAllDay, setIsAllDay] = useState(false);
  const [recurrenceRule, setRecurrenceRule] = useState("");
  const [owner, setOwner] = useState(null);
  const [meetingProject, setMeetingProject] = useState(null);
  const [agendaItems, setAgendaItems] = useState([]);
  const [discussionItems, setDiscussionItems] = useState([]);
  const [descisionItems, setDescisionItems] = useState([]);
  const [actionItems, setActionItems] = useState([]);
  const [followupItems, setFollowupItems] = useState([]);
  const [notes, setNotes] = useState("");
  const [generateMinutes, setGenerateMinutes] = useState(false);
  const [dateCanceled, setDateCanceled] = useState(null);
  //
  const [itemChecked, setItemChecked] = useState(false);
  // const [inputValue, setInputValue] = useState("");
  const [inputValues, setInputValues] = useState({
    agenda: '',
    descision: '',
    discussion: '',
    action: '',
    followup: ''
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    startDate: "",
    endDate: "",
    owner: "",
  });

  const getTimeFormatOptions = () => {
    const timeFormat = settings?.regionalSettings?.timeFormat;
    if (!timeFormat) return { hour: "numeric", minute: "2-digit" };

    const usesAmPm = timeFormat.toLowerCase().includes("a");

    return {
      hour: "numeric",
      minute: "2-digit",
      meridiem: usesAmPm ? "short" : undefined,
      hour12: usesAmPm,
    };
  };

  // const handlePopoverOpen = (rowId) => {
  //   setPopoverOpen(rowId);
  // };

  // const handleClickOutside = (event) => {
  //   if (
  //     popoverRef.current &&
  //     event.target?.innerText !== "Cancel" &&
  //     event.target?.innerText !== "Delete"
  //   ) {
  //     handlePopoverOpen(null);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const InitStateData = () => {
    setSelectedMeeting(null);
    setName("");
    setAttendees([]);
    setStartDate(null);
    setEndDate(null);
    setIsAllDay(false);
    setRecurrenceRule("");
    setOwner(null);
    setMeetingProject(null);
    setAgendaItems([]);
    setDiscussionItems([]);
    setDescisionItems([]);
    setActionItems([]);
    setFollowupItems([]);
    setNotes("");
    setGenerateMinutes(false);
    setFormErrors({});
    setIsEditingDisabled(false);
    setInputValues({
      agenda: '',
      descision: '',
      discussion: '',
      action: '',
      followup: ''
    });
  };

  const handleCreate = () => {
    InitStateData();
    setIsEdit(false);
    const nowUtc = moment.utc();
    const startDate = nowUtc.format();
    const endDate = nowUtc.clone().add(30, "minutes").format();

    setStartDate(startDate);
    setEndDate(endDate);
    setOwner(userInfoDto);
    if (project && project.id !== "all") {
      const currentProject = { label: project.name, value: project.id };
      setMeetingProjects([currentProject]);
      setMeetingProject(currentProject);
    }
    setShowModal(true);
  };

  const handleSave = () => {
    const errors = {};
    if (!Name) errors["name"] = `Required`;
    if (!startDate) errors["startDate"] = `Required`;
    if (!endDate) errors["endDate"] = `Required`;
    if (!owner) errors["owner"] = `Required`;

    const startDateTime = moment().utc(startDate).local();
    const endDateTime = moment().utc(endDate).local();

    if (endDateTime < startDateTime) {
      errors["startDate"] = errors["endDate"] = "";
      dispatch(
        generalActions.showToast({
          title: "Meeting Start time must be before end time",
          type: "error",
        })
      );
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    let payload = {
      name: Name,
      ownerId: owner?.id,
      projectId: meetingProject ? meetingProject.value : null,
      attendees: attendees.length > 0 ? attendees.map((a) => a.id) : [],
      startTime: startDate,
      endTime: endDate,
      isAllDay: isAllDay,
      isRecurring: recurrenceRule !== "",
      recurrenceRule: recurrenceRule,
      agenda: agendaItems?.length > 0 ? JSON.stringify(agendaItems) : "",
      discussions:
        discussionItems?.length > 0 ? JSON.stringify(discussionItems) : "",
      decisions:
        descisionItems?.length > 0 ? JSON.stringify(descisionItems) : "",
      actions: actionItems?.length > 0 ? JSON.stringify(actionItems) : "",
      followUps: followupItems?.length > 0 ? JSON.stringify(followupItems) : "",
      notes: notes,
      generateMinutes: generateMinutes,
    };

    if (selectedMeeting) {
      payload.editType = eventActionType;
      updateMeetingRequest({
        id: selectedMeeting,
        isOccurrence: isOccurrence,
        payload: payload,
        dates: calendarDates,
      });
    } else {
      createMeetingRequest({ payload, dates: calendarDates });
    }
    setEventActionType(null);
  };

  const viewMeeting = (item) => {
    InitStateData();
    fetchSingleMeeting(item);
  };

  const fetchSingleMeeting = (item) => {
    setIsLoading(true);
    setSelectedMeeting(item.id);
    meetingService
      .fetchMettingRequest(item.id, item.isOccurrence)
      .then((meeting) => {
        setIsOccurrence(meeting.isOccurrence);
        setName(meeting.name);
        setAttendees(meeting.participants || []);
        setStartDate(meeting.startTime);
        setEndDate(meeting.endTime);
        setIsAllDay(meeting.isAllDay);
        setRecurrenceRule(meeting.recurrenceRule);
        setOwner(meeting.owner);
        setMeetingProject(
          meeting.project
            ? { label: meeting.project.name, value: meeting.project.id }
            : null
        );
        setAgendaItems(meeting.agenda ? JSON.parse(meeting.agenda) : []);
        setDiscussionItems(
          meeting.discussions ? JSON.parse(meeting.discussions) : []
        );
        setDescisionItems(
          meeting.decisions ? JSON.parse(meeting.decisions) : []
        );
        setActionItems(meeting.actions ? JSON.parse(meeting.actions) : []);
        setFollowupItems(
          meeting.followUps ? JSON.parse(meeting.followUps) : []
        );
        setNotes(meeting.notes);
        setGenerateMinutes(meeting.generateMinutes);
        setDateCanceled(meeting.dateCanceled);

        setIsEdit(true);
        setIsEditingDisabled(
          user.id !== meeting.owner.id && user.id !== meeting.creator.id
        );
        setShowModal(true);
      })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title:
              "Something went wrong fetching data. Please try again later.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleEvents = (events) => {
    console.log("handleEvents", events);
    setCurrentEvents(events);
  };

  useEffect(() => {
    if (!loading) {
      if (!isKeepModalOpen) {
        setShowConfirmationModal(false);
        setShowDeleteModal(false);
        setShowModal(false);
        setIsEdit(false);
        InitStateData();
      } else {
        setIsKeepModalOpen(false);
      }
    }
  }, [loading]);

  useEffect(() => {
    if (Array.isArray(meetings) && meetings.length > 0) {
      const formattedEvents = meetings.map((meeting, index) => ({
        id: meeting.isOccurrence
          ? meeting.occurenceId
            ? meeting.occurenceId
            : `OCC-${index}@${meeting.id}`
          : meeting.id,
        parentMeetingId: meeting.id,
        occurenceId: meeting.occurenceId,
        isOccurrence: meeting.isOccurrence,
        isRecurring: meeting.isRecurring,
        isCanceled: meeting.dateCanceled ? true : false,
        isEditingDisabled:
          user.id !== meeting.owner.id && user.id !== meeting.creator.id,
        isAllDay: meeting.isAllDay,
        title: meeting.name,
        start: meeting.startTime,
        end: meeting.endTime,
        titleTime: meeting.isAllDay ? 'all day' : utcToLocalTimeString(settings, meeting.startTime),
        project: meeting.project
      }));

      setEventsList(formattedEvents);
      if (rangeIncludesToday(calendarDates.startDate, calendarDates.endDate)) {
        setTodaysEventsList(
          formattedEvents.filter((m) =>
            moment.utc(m.start).local().isSame(moment(), "day")
          )
        );
      }
    } else {
      setEventsList([]);
    }
  }, [meetings]);

  const rangeIncludesToday = (utcStartStr, utcEndStr) => {
    const start = moment.utc(utcStartStr).local();
    const end = moment.utc(utcEndStr).local();

    const todayStart = moment().startOf("day");
    const todayEnd = moment().endOf("day");

    return start.isSameOrBefore(todayEnd) && end.isSameOrAfter(todayStart);
  };

  const getDate = (dateString) => {
    const date = new Date(dateString);

    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const monthsOfYear = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayOfWeek = daysOfWeek[date.getDay()];
    const month = monthsOfYear[date.getMonth()];
    const dayOfMonth = date.getDate();

    const formattedDate = `${dayOfWeek}, ${month} ${dayOfMonth}`;
    return formattedDate;
  };

  const getTime = (time) => {
    const date = new Date(time);

    const hours = date.getHours();
    const minutes = date.getMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 || 12; // Convert to 12-hour format

    const displayMinutes = minutes < 10 ? "0" + minutes : minutes;

    const formattedTime = `${displayHours}:${displayMinutes} ${ampm}`;

    return formattedTime;
  };

  const renderMeetings = () => {
    if (todaysEventsList && todaysEventsList.length > 0) {
      return (
        <div className={`${styles.meetingsListingWrapper}`}>
          {todaysEventsList.map((meeting) => (
            <div
              className={`${styles.meetingsItemContainer}`}
            >
              {meeting.project && (
                <div className="d-flex justify-content-start align-items-center mb-1">
                  <div>
                    <p className="text-xsm-400 grey36Color">
                      <span className={`${styles.ProjectPill}`}>
                        {meeting.project.name}
                      </span>
                    </p>
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="text-xsm-400 grey36Color">
                    {meeting.isAllDay ? (
                      <span className={`all-day-pill ${styles.allDayPill}`}>
                        All day
                      </span>
                    ) : (
                      `${getTime(meeting.start)} - ${getTime(meeting.end)}`
                    )}
                  </p>
                </div>
                {meeting.isRecurring && <ArrowRepeatAllIcon />}
                {meeting.dateCanceled && (
                  <p className={styles.cancelText}>Cancelled</p>
                )}
              </div>
              <p className="d-flex align-items-center text-sm-600 subHeading-color mt-6">
                {meeting.title}
              </p>
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className={`${styles.meetingCalendarContainer}`}>
            <p className={`${styles.noMeetingTitle}`}>
              Nothing planned for the day
            </p>
            <img src={Calendar} alt="calendar" />
            <p className={`${styles.enjoyTitle}`}>Enjoy!</p>
          </div>
        </div>
      );
    }
  };

  const handleKeyDown = (event, type) => {
    if (isEditingDisabled) return;
    if (event.key === 'Enter' && inputValues[type]?.trim()) {
      const obj = { completed: false, text: inputValues[type].trim() };
      switch (type) {
        case "agenda":
          setAgendaItems((prev) => [...prev, obj]);
          break;
        case "discussion":
          setDiscussionItems((prev) => [...prev, obj]);
          break;
        case "descision":
          setDescisionItems((prev) => [...prev, obj]);
          break;
        case "action":
          setActionItems((prev) => [...prev, obj]);
          break;
        case "followup":
          setFollowupItems((prev) => [...prev, obj]);
          break;
        default:
          return;
      }
      setInputValues(prev => ({
        ...prev,
        [type]: ''
      }));
    }
  };

  const handleInputChange = (e, type) => {
    if (!isEditingDisabled) {
      setInputValues(prev => ({
        ...prev,
        [type]: e.target.value
      }));
    }
  };

  const handleChecked = (event, item, type) => {
    if (isEditingDisabled) return;

    switch (type) {
      case "agenda": {
        agendaItems.filter((i) => {
          if (i.text === item.text) i.completed = event;
          return;
        });
        break;
      }
      case "descision": {
        descisionItems.filter((i) => {
          if (i.text === item.text) i.completed = event;
          return;
        });
        break;
      }
      case "discussion": {
        discussionItems.filter((i) => {
          if (i.text === item.text) i.completed = event;
          return;
        });
        break;
      }
      case "action": {
        actionItems.filter((i) => {
          if (i.text === item.text) i.completed = event;
          return;
        });
        break;
      }
      case "followup": {
        followupItems.filter((i) => {
          if (i.text === item.text) i.completed = event;
          return;
        });
        break;
      }
      default:
        return "";
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setIsEdit(false);
    InitStateData();
    setEventActionType(null);
  };

  const meetingProjectSearchdebounced = useRef(
    debounce((value) => searchMeetingProjectHandler(value), 500)
  );
  const MeetingProjectSearch = useCallback((value) => {
    meetingProjectSearchdebounced.current(value);
  }, []);

  const searchMeetingProjectHandler = (value) => {
    searchService
      .Projects(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
          image: obj.image,
        }));
        setMeetingProjects(transformedArray);
      })
      .catch(() => {
        setMeetingProjects([]);
      });
  };

  const handleAddEvent = (selectInfo) => {
    InitStateData();
    setIsEdit(false);
    const startDateUtc = moment(
      selectInfo.allDay
        ? new Date(selectInfo.start.getTime() + 1 * 60 * 1000)
        : selectInfo.start
    ).utc();
    const endDateUtc = moment(
      selectInfo.allDay
        ? new Date(selectInfo.end.getTime() - 1 * 60 * 1000)
        : selectInfo.end
    ).utc();

    setStartDate(startDateUtc.format());
    setEndDate(endDateUtc.format());
    setIsAllDay(selectInfo.allDay);
    setOwner(userInfoDto);
    if (project && project.id != "all") {
      const currentProject = { label: project.name, value: project.id };
      setMeetingProjects([currentProject]);
      setMeetingProject(currentProject);
    }
    setShowModal(true);
  };

  const getCalendarViewDates = (view = "") => {
    const calendarApi = calendarRef.current.getApi();

    switch (view) {
      case "prev":
        calendarApi.prev();
        break;
      case "next":
        calendarApi.next();
        break;
      case "today":
        calendarApi.today();
        break;
      default:
        break;
    }

    var startDate = moment(calendarApi.view.activeStart).utc().format();
    var endDate = moment(calendarApi.view.activeEnd).utc().format();
    return { startDate, endDate };
  };

  useEffect(() => {
    refreshCalendar();
  }, []);

  const refreshCalendar = (view = "", selectedProject) => {
    const datesRange = getCalendarViewDates(view);
    setCalendarDates(datesRange);
    const c_project = selectedProject ? selectedProject : project;
    const isAll = c_project?.id === "all";
    getMeetings(
      `StartDate=${datesRange.startDate}&EndDate=${datesRange.endDate}${isAll ? "" : `&projectId=${c_project.id}`
      }`
    );
  };

  const handlePrevClick = () => {
    refreshCalendar("prev");
  };

  const handleNextClick = () => {
    refreshCalendar("next");
  };

  const handleTodayClick = () => {
    refreshCalendar("today");
  };

  const updateMeetingDates = (payload, revert) => {
    meetingService
      .updateMettingDatesRequest(payload)
      .then(() => {
        refreshCalendar();
      })
      .catch(() => {
        revert();
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      });
  };

  const handleEventResize = (resizeInfo) => {
    handleMeetingDatesChanged(resizeInfo);
  };

  const handleMeetingDatesChanged = (eventInfo) => {
    const { event, oldEvent, newEvent, revert } = eventInfo;
    const meetingInfo = event._def.extendedProps;

    var isSameDay = moment(oldEvent.start).isSame(event.start, "day");
    if (meetingInfo.isOccurrence && !isSameDay) {
      revert();
      dispatch(
        generalActions.showToast({
          title:
            "Forbidden operation: You cannot change the date of an event in a recurrence. Only the time can be modified",
          type: "warning",
        })
      );
      return;
    }

    if (isEditingDisabled) {
      revert();
      dispatch(
        generalActions.showToast({
          title:
            "Forbidden operation: Only the meeting owner or creator can update meeting details",
          type: "warning",
        })
      );
      return;
    }
    const payload = {
      startTime: moment(event.start).utc().format(),
      endTime: moment(event.end).utc().format(),
      all: true,
    };

    if (meetingInfo.isOccurrence) {
      if (!meetingInfo.occurenceId) {
        const params = {
          isOccurrence: true,
          parentMeetingId: meetingInfo.parentMeetingId,
          inherit: true,
          payload: {
            startTime: payload.startDate,
          },
        };

        meetingService
          .createMettingRequest(params)
          .then((occurence) => {
            updateMeetingDates(
              {
                id: occurence.occurenceId,
                isOccurrence: true,
                payload: payload,
              },
              revert
            );
          })
          .catch((error) => {
            throw error;
          });
      } else {
        updateMeetingDates(
          { id: meetingInfo.occurenceId, isOccurrence: true, payload: payload },
          revert
        );
      }
    } else {
      updateMeetingDates(
        {
          id: meetingInfo.parentMeetingId,
          isOccurrence: false,
          payload: payload,
        },
        revert
      );
    }
  };
  const handleEventDrop = (dropInfo) => {
    handleMeetingDatesChanged(dropInfo);
  };

  const isSameDay = (startDate, endDate) =>
    moment(moment.utc(startDate).local().toDate()).isSame(
      moment(moment.utc(endDate).local().toDate()),
      "day"
    );

  const formatDate = (date) =>
    moment(date).format(
      dateFormat
        ? dateFormat.replace(/dd/g, "DD").replace(/yy/g, "YY")
        : dateFormat
    );
  const formatDateTime = (date) =>
    moment(date).format(
      `${dateFormat
        ? dateFormat.replace(/dd/g, "DD").replace(/yy/g, "YY")
        : dateFormat
      } ${timeFormat}`
    );

  const handleEventClick = (clickInfo) => {
    setEventPopupData({
      event: clickInfo.event,
      position: {
        x: clickInfo.jsEvent.clientX,
        y: clickInfo.jsEvent.clientY,
      },
    });
  };

  const handleEventHover = (event, eventInfo) => {
    setEventPopupData({
      event: eventInfo,
      position: {
        x: event.clientX,
        y: event.clientY,
      },
    });
  };

  const handleClosePopup = () => {
    setEventPopupData(null);
  };

  const handleMouseEnter = (info) => {
    const event = info.event;
    const meetingInfo = event._def.extendedProps;
    const titleTime = meetingInfo.titleTime ?? "";

    const tooltipContent = `
      <div class="tooltip-inner">
        <div class="${meetingInfo.project ? 'tooltip-meeting-project' : ''}">
         ${meetingInfo.project ? `${meetingInfo.project?.name}` : ''}  
        </div>
        <div class="tooltip-meeting-title ${meetingInfo.isCanceled ? 'tooltip-meeting-cancelled' : ''}">
          <div class="${meetingInfo.isCanceled ? 'tooltip-meeting-time' : ''} tooltip-meeting-cancelled">
          ${meetingInfo.isCanceled ? 'Cancelled' : ''}
          </div>
          <div class="tooltip-meeting-time ${meetingInfo.isCanceled ? 'tooltip-meeting-cancelled' : ''}">
            ${titleTime}
            ${meetingInfo.isRecurring ? `- Recurring` : ''}
          </div>
          ${event.title}
        </div>
      </div>
    `;

    tooltipInstance = new Tooltip(info.el, {
      title: tooltipContent,
      html: true,
      placement: "bottom",
      trigger: "hover",
      container: "body",
      customClass: "meeting-tooltip",
      offset: [0, 8]
    });

    tooltipInstance.show();
  };

  const handleMouseLeave = (info) => {
    if (tooltipInstance) {
      tooltipInstance.dispose();
      tooltipInstance = null;
    }
  };

  const handleEditEvent = (event, eventType) => {
    handleEditMeeting(event, eventType);
  };

  const handleDeleteEvent = (event, eventType) => {
    const meetingInfo = event._def.extendedProps;
    setEventActionType(eventType);
    if (eventType != 2 && meetingInfo.isOccurrence) {
      if (!meetingInfo.occurenceId) {
        setIsLoading(true);

        const params = {
          isOccurrence: true,
          parentMeetingId: meetingInfo.parentMeetingId,
          inherit: true,
          payload: {
            startTime: moment(event.start).utc().format(),
          },
        };

        meetingService
          .createMettingRequest(params)
          .then((occurence) => {
            setIsKeepModalOpen(true);
            refreshCalendar();
            setSelectedMeeting(occurence.occurenceId);
            setIsOccurrence(true);
            setShowDeleteModal(true);
          })
          .catch(() => {
            setEventActionType(null);
            dispatch(
              generalActions.showToast({
                title:
                  "Something went wrong fetching data. Please try again later.",
                type: "error",
              })
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        setSelectedMeeting(meetingInfo.occurenceId);
        setIsOccurrence(true);
        setShowDeleteModal(true);
      }
    } else {
      setSelectedMeeting(meetingInfo.parentMeetingId);
      setIsOccurrence(false);
      setShowDeleteModal(true);
    }
  };

  const handleCancelEvent = (event, eventType) => {
    const meetingInfo = event._def.extendedProps;
    setEventActionType(eventType);
    if (eventType != 2 && meetingInfo.isOccurrence) {
      if (!meetingInfo.occurenceId) {
        setIsLoading(true);

        const params = {
          isOccurrence: true,
          parentMeetingId: meetingInfo.parentMeetingId,
          inherit: true,
          payload: {
            startTime: moment(event.start).utc().format(),
          },
        };

        meetingService
          .createMettingRequest(params)
          .then((occurence) => {
            setIsKeepModalOpen(true);
            refreshCalendar();
            setSelectedMeeting(occurence.occurenceId);
            setIsOccurrence(true);
            setShowConfirmationModal(true);
          })
          .catch(() => {
            setEventActionType(null);
            dispatch(
              generalActions.showToast({
                title:
                  "Something went wrong fetching data. Please try again later.",
                type: "error",
              })
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        setSelectedMeeting(meetingInfo.occurenceId);
        setIsOccurrence(true);
        setShowConfirmationModal(true);
      }
    } else {
      setSelectedMeeting(meetingInfo.parentMeetingId);
      setIsOccurrence(false);
      setShowConfirmationModal(true);
    }
  };

  const handleEditMeeting = (event, actionType) => {
    const meetingInfo = event._def.extendedProps;
    setEventActionType(actionType);
    if (actionType != 2 && meetingInfo.isOccurrence) {
      if (!meetingInfo.occurenceId) {
        setIsLoading(true);

        const params = {
          isOccurrence: true,
          parentMeetingId: meetingInfo.parentMeetingId,
          inherit: true,
          payload: {
            startTime: moment(event.start).utc().format(),
          },
        };

        meetingService
          .createMettingRequest(params)
          .then((occurence) => {
            setIsKeepModalOpen(true);
            refreshCalendar();
            viewMeeting({ id: occurence.occurenceId, isOccurrence: true });
          })
          .catch(() => {
            setEventActionType(null);
            dispatch(
              generalActions.showToast({
                title:
                  "Something went wrong fetching data. Please try again later.",
                type: "error",
              })
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        viewMeeting({ id: meetingInfo.occurenceId, isOccurrence: true });
      }
    } else {
      viewMeeting({ id: meetingInfo.parentMeetingId, isOccurrence: false });
    }
  };

  const handleDelete = () => {
    deleteMeetingRequest({
      id: selectedMeeting,
      isOccurrence: isOccurrence,
      editType: eventActionType,
      dates: calendarDates,
    });

    setEventActionType(null);
  };

  const handleCancelMeeting = () => {
    cancelMeetingRequest({
      id: selectedMeeting,
      isOccurrence: isOccurrence,
      editType: eventActionType,
      dates: calendarDates,
    });
    setEventActionType(null);
  };

  const handleChangeProject = (project) => {
    setIsOpenPopover(null);
    setProject(project);
    refreshCalendar("", project);
  };

  const handleMeetingDaysChange = (data) => {
    setStartDate(data.startDate);
    setEndDate(data.endDate);
    setIsAllDay(data.allDay);
    setRecurrenceRule(data.recurringRule);
  };

  const handleMeetingProjectChange = (project) => {
    setMeetingProject(project);
    setOwner(null);
    setAttendees([]);
  }
  const formBody = () => {
    return (
      <>
        <div className="d-flex align-items-center w-100 mb-4">
          <img src={Pencil} alt="" className={styles.icons} />
          <Input
            inputwd="w-100"
            icon={false}
            placeholder="Add a title"
            value={Name}
            type="text"
            handleChange={setName}
            errorMessage={formErrors.name}
            isRequired
            loading={isLoading}
            isDisabled={isEditingDisabled}
          />
        </div>
        <div className={`d-flex align-items-center mb-3`}>
          <>
            <img src={Projects} alt="" className={styles.icons} />
            {isOccurrence ? (
              <div className="col-4">
                <p
                  className=" text-[#1F1F1F] bg-[#EDECF8] text-center py-[9px] rounded-md"
                  style={{ border: "1px solid #342C82" }}
                >
                  {meetingProject.label}
                </p>
              </div>
            ) : (
              <Searchable
                SelectText="Project"
                selectWd={styles.dropdownWd}
                searchText={MeetingProjectSearch}
                options={meetingProjects}
                defaultVal={meetingProject}
                onChange={(e) => handleMeetingProjectChange(e)}
                creatable={false}
                setCreated={setMeetingProject}
                loading={isLoading}
                isDisabled={isEditingDisabled}
              />
            )}
          </>
        </div>
        <div className={`d-flex align-items-center mb-3`}>
          <>
            <img src={Person} alt="" className={styles.icons} />
            <UserSelect
              isAdminSearch={true}
              refType={meetingProject ? UserSearchRefType.Project : null}
              refId={meetingProject ? meetingProject?.value : null}
              label=""
              buttonLabel={"Select Owner"}
              value={owner}
              onChange={setOwner}
              errorMessage={formErrors.owner}
              loading={isLoading}
              isRequired
              disabled={isEditingDisabled}
              style={{ minHeight: "40px" }}
            />
          </>
        </div>
        <div className="d-flex align-items-center gx-3 w-100 mb-3">
          <div className="w-[20px] h-[20px] mr-[12px]"></div>
          <UserSelect
            isAdminSearch={true}
            multiple={true}
            refType={meetingProject ? UserSearchRefType.Project : null}
            refId={meetingProject ? meetingProject?.value : null}
            label=""
            buttonLabel={"Select Attendees"}
            value={attendees}
            onChange={setAttendees}
            loading={isLoading}
            disabled={isEditingDisabled}
          />
        </div>
        {!isLoading && (
          <div className="d-flex align-items-baseline w-100 mb-3 column-gap-1">
            <MeetingDays
              startDate={startDate}
              endDate={endDate}
              allDay={isAllDay}
              recurringRule={recurrenceRule}
              onChange={handleMeetingDaysChange}
              className="min-w-[95%] ml-[30px]"
            />
          </div>
        )}
        {isLoading ? (
          <Skeleton height={300} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
        ) : (
          <div className={`d-flex align-items-start w-100`}>
            <img src={NotesIcon} alt="" className={styles.icons} />
            <div className={styles.meetingNotesContainer}>
              <div className={styles.meetingNotes}>
                <p
                  onClick={() => setShowNotes(!showNotes)}
                  className={styles.meetingNotesTitle}
                >
                  Meeting notes
                </p>
                <div className="flex items-center gap-2">
                  <MinimalistToggle
                    title="Generate Minutes"
                    checked={generateMinutes}
                    onChange={setGenerateMinutes}
                    disabled={isEditingDisabled}
                  />
                </div>

              </div>

              {showNotes && (
                <div className="meetingAccordianContainer">
                  <Accordion collapsible multiple>
                    <AccordionItem value="1">
                      <AccordionHeader>Agenda Items</AccordionHeader>
                      <AccordionPanel>
                        {agendaItems &&
                          agendaItems.map(
                            (item, index) => (
                              <NotesItem
                                label={item.text}
                                key={index}
                                checked={itemChecked}
                                isDisabled={isEditingDisabled}
                                setChecked={(e) =>
                                  handleChecked(e, item, "agenda")
                                }
                              />
                            )
                            // <Checkbox label={item.text} key={index} checked={itemChecked} setChecked={(e) => handleChecked(e, item, 'agenda')} />
                          )}
                        {!isEditingDisabled && (
                          <input
                            className="meetingNotesInput w-100"
                            type="text"
                            placeholder="Add item"
                            value={inputValues.agenda || ''}
                            disabled={isEditingDisabled}
                            onChange={(e) => handleInputChange(e, "agenda")}
                            onKeyDown={(e) => handleKeyDown(e, "agenda")}
                          />
                        )}
                      </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem value="2">
                      <AccordionHeader>Discussion Points</AccordionHeader>
                      <AccordionPanel>
                        {descisionItems &&
                          descisionItems.map((item, index) => (
                            <NotesItem
                              label={item.text}
                              key={index}
                              checked={itemChecked}
                              isDisabled={isEditingDisabled}
                              setChecked={(e) =>
                                handleChecked(e, item, "descision")
                              }
                            />
                          ))}
                        {!isEditingDisabled && (
                          <input
                            className="meetingNotesInput w-100"
                            type="text"
                            placeholder="Add item"
                            value={inputValues.descision || ''}
                            disabled={isEditingDisabled}
                            onChange={(e) => handleInputChange(e, "descision")}
                            onKeyDown={(e) => handleKeyDown(e, "descision")}
                          />
                        )}
                      </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem value="3">
                      <AccordionHeader>Descision Made</AccordionHeader>
                      <AccordionPanel>
                        {discussionItems &&
                          discussionItems.map((item, index) => (
                            <NotesItem
                              label={item.text}
                              key={index}
                              checked={itemChecked}
                              isDisabled={isEditingDisabled}
                              setChecked={(e) =>
                                handleChecked(e, item, "discussion")
                              }
                            />
                          ))}
                        {!isEditingDisabled && (
                          <input
                            className="meetingNotesInput w-100"
                            type="text"
                            placeholder="Add item"
                            value={inputValues.discussion || ''}
                            disabled={isEditingDisabled}
                            onChange={(e) => handleInputChange(e, "discussion")}
                            onKeyDown={(e) => handleKeyDown(e, "discussion")}
                          />
                        )}
                      </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem value="4">
                      <AccordionHeader>Action Items</AccordionHeader>
                      <AccordionPanel>
                        {actionItems &&
                          actionItems.map((item, index) => (
                            <NotesItem
                              label={item.text}
                              key={index}
                              checked={itemChecked}
                              isDisabled={isEditingDisabled}
                              setChecked={(e) =>
                                handleChecked(e, item, "action")
                              }
                            />
                          ))}
                        {!isEditingDisabled && (
                          <input
                            className="meetingNotesInput w-100"
                            type="text"
                            placeholder="Add item"
                            value={inputValues.action || ''}
                            disabled={isEditingDisabled}
                            onChange={(e) => handleInputChange(e, "action")}
                            onKeyDown={(e) => handleKeyDown(e, "action")}
                          />
                        )}
                      </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem value="5">
                      <AccordionHeader>Follow-up Items</AccordionHeader>
                      <AccordionPanel>
                        {followupItems &&
                          followupItems.map((item, index) => (
                            <NotesItem
                              label={item.text}
                              key={index}
                              checked={itemChecked}
                              isDisabled={isEditingDisabled}
                              setChecked={(e) =>
                                handleChecked(e, item, "followup")
                              }
                            />
                          ))}
                        {!isEditingDisabled && (
                          <input
                            className="meetingNotesInput w-100"
                            type="text"
                            placeholder="Add item"
                            value={inputValues.followup || ''}
                            disabled={isEditingDisabled}
                            onChange={(e) => handleInputChange(e, "followup")}
                            onKeyDown={(e) => handleKeyDown(e, "followup")}
                          />
                        )}
                      </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem value="6">
                      <AccordionHeader>Meeting Notes</AccordionHeader>
                      <AccordionPanel>
                        <RichTextEditor
                          content={notes}
                          onChange={setNotes}
                          loading={isLoading}
                          disabled={isEditingDisabled}
                        />
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  const projectSearchdebounced = useRef(
    debounce((value) => searchProjectsHandler(value), 500)
  );

  const handleProjectSearch = useCallback((value) => {
    projectSearchdebounced.current(value);
  }, []);

  const renderEventContent = (eventInfo) => {
    const isCanceled = eventInfo.event._def.extendedProps.isCanceled;
    const isRecurring = eventInfo.event._def.extendedProps.isRecurring;
    const titleTime = eventInfo.event._def.extendedProps.titleTime ?? "";

    return (
      <div className={`${styles.meetingTitleCellContainer} CustomEvent`} >
        <p
          className={`${styles.meetingTitleCell} ${isCanceled ? styles.meetingCanceled : ""
            }`}
        >
          {`${isCanceled ? "Canceled: " : ""}  ${titleTime} - ${eventInfo.event.title}`}
        </p>
        {isRecurring && (
          <div className={styles.meetingReccuringIconCell}>
            <ArrowRepeatAllIcon />
          </div>
        )}
      </div>
    );
  };

  const searchProjectsHandler = (term) => {
    searchService
      .Projects(term)
      .then((res) => {
        setProjects([{ name: "All Projects", id: "all" }, ...res]);
      })
      .catch(() => {
        setProjects([]);
      });
  };

  const handleProjects = () => {
    handleProjectSearch("");
    setIsOpenPopover("projects");
  };

  return (
    <div className={`${styles.MeetingScreen}`} ref={popoverRef}>
      <div className="db_Subheader d-flex justify-content-between align-items-center mb-20">
        <h4 className={`${styles.meetingHeading} text-lg-600`}>Meetings</h4>
        <div className="custom-row-meetings-header-task">
          <CustomPopover
            width={"364px"}
            icon={
              <Button
                btnClass="ProjectSelect text-sm-600 subHeading-color"
                label={
                  project.name.length > 12
                    ? `${project.name.substring(0, 8)}..`
                    : project.name
                }
                rightIcon={
                  <span className="ms-1 d-inline-flex">
                    <RegularArrowDownIcon />
                  </span>
                }
                clickHandler={handleProjects}
              />
            }
            status={openPopover === "projects"}
          >
            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between align-items-center  ">
                <h6 className=" ">Filter by projects</h6>
                <div onClick={() => setIsOpenPopover(null)}>
                  <Cross />
                </div>
              </div>
              <div>
                <IconInput
                  icon={<SearchIcon />}
                  placeholder={"Search"}
                  handleChange={handleProjectSearch}
                />
              </div>
              <div style={{ height: "176px", overflow: "auto" }}>
                <div className="d-flex flex-wrap gap-2">
                  {projects.map((p) => (
                    <span
                      className={`${styles.projectItem} ${p.id == "all"
                        ? styles.allProjectsItem
                        : project.id === p.id
                          ? styles.selectedProjectItem
                          : ""
                        }`}
                      value={p.id}
                      onClick={() => {
                        handleChangeProject(p);
                      }}
                    >
                      {p.name}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </CustomPopover>

          {permissions && permissions.includes("Meeting.Create") && (
            <Button
              btnClass="d_btn d_btn_primary text-sm-600"
              icon={<AddIconSvg />}
              label="New meeting"
              clickHandler={handleCreate}
            />
          )}
        </div>
      </div>

      <div className={`${styles.calanderWrapper}`}>
        <div className="col-10">
          <div className="calanderMain">
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "today prev,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
              }}
              initialView="dayGridMonth"
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              weekends={weekendsVisible}
              events={eventsList}
              eventTimeFormat={getTimeFormatOptions()}
              slotLabelFormat={getTimeFormatOptions()}
              select={handleAddEvent}
              eventContent={renderEventContent}
              eventClick={handleEventClick}
              eventResize={handleEventResize}
              eventMouseEnter={handleMouseEnter}
              eventMouseLeave={handleMouseLeave}
              eventDrop={handleEventDrop}
              eventsSet={handleEvents} // called after events are initialized/added/changed/removed
              customButtons={{
                prev: {
                  text: "Prev", // Text to display on the button
                  click: handlePrevClick, // Function to handle click event
                },
                next: {
                  text: "Next", // Text to display on the button
                  click: handleNextClick, // Function to handle click event
                },
                today: {
                  text: "Today",
                  click: handleTodayClick,
                },
              }}
            // eventAdd={function(){}}
            // eventChange={function(){}}
            // eventRemove={function(){}}
            //  eventColor=''
            />
          </div>
        </div>
        <div className="col-2">
          <div className={`${styles.meetingsListingContainer}`}>
            <div className={`${styles.meetingsListingHeader}`}>
              <p className={`${styles.meetingsListingTitle}`}>
                {getDate(new Date())}
              </p>
            </div>
            <div className={`${styles.heightMeetingBody}`}>
              {renderMeetings()}
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Modal
          title={`${isEdit
            ? !isEditingDisabled
              ? "Edit Meeting"
              : "Meeting Details"
            : "New Meeting"
            }`}
          zIndex={true}
          handleCancel={() => handleCancel(false)}
          handleSave={handleSave}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={loading}
          size="large"
          footer={!isEditingDisabled}
          body={formBody()}
        />
      )}
      {showDeleteModal && (
        <Modal
          title="Delete meeting"
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the meeting?`}</p>
          }
          handleCancel={() => setShowDeleteModal(false)}
          handleSave={() => handleDelete()}
          cancelBtnLabel="Cancel"
          saveBtnLabel="Delete"
          isLoading={loading}
        />
      )}
      {eventPopupData && (
        <EventPopup
          event={eventPopupData.event}
          position={eventPopupData.position}
          onClose={handleClosePopup}
          onEdit={handleEditEvent}
          onDelete={handleDeleteEvent}
          onCancel={handleCancelEvent}
        />
      )}
      {showConfirmationModal && (
        <Modal
          title="Cancel meeting"
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to cancel the meeting?`}</p>
          }
          handleCancel={() => setShowConfirmationModal(false)}
          handleSave={() => handleCancelMeeting()}
          saveBtnLabel="Confirm"
          cancelBtnLabel="Cancel"
          isLoading={loading}
        />
      )}
    </div>
  );
};

export default Meetings;
